import { get, set } from 'lodash'
import createClient from './shopifyClient'

class ShopifyRepository {

  constructor(options) {
    this.client = createClient(options)
  }

	async loadUrls(query, variables) {
		let prods = await this.client.query({ query, variables })
		return this.parseUrls(get(prods, 'data.products.edges'))
	}

	async loadQuery(query, variables) {
		return await this.client.query({ query, variables })
  }

  async createMutation(mutation, variables) {
    return await this.client.mutate({ mutation, variables })
  }

  parseUrls (products) {
    return products.map(product => this.parseUrl(product))
  }

  parseUrl (product) {
    let url = '/products/' + get(product, 'node.handle')

    product.url = url
    set(product, 'node.url', url)

    return product
  }
}

export default ShopifyRepository
